var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcSubscription(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 65.335,
    height: 65.345,
    viewBox: "0 0 65.335 65.345",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "_022-wallet_passes_app",
    "data-name": "022-wallet passes app",
    d: "M62.821,18a2.552,2.552,0,0,0,2.552-2.552V12.77A12.785,12.785,0,0,0,52.6,0S12.6.006,12.5.018A13.029,13.029,0,0,0,3.564,4.023,12.58,12.58,0,0,0,.045,13.212c0,.065-.007,36.811-.007,36.811A15.34,15.34,0,0,0,15.36,65.345H52.6a12.785,12.785,0,0,0,12.77-12.77V33.2A12.785,12.785,0,0,0,52.6,20.427H12.8A7.642,7.642,0,0,1,5.15,13.136,7.523,7.523,0,0,1,7.256,7.547a7.9,7.9,0,0,1,5.687-2.433L52.6,5.1a7.675,7.675,0,0,1,7.666,7.666v2.68A2.552,2.552,0,0,0,62.821,18ZM12.8,25.531H52.6A7.675,7.675,0,0,1,60.268,33.2V52.574A7.675,7.675,0,0,1,52.6,60.24H15.36A10.23,10.23,0,0,1,5.142,50.022V22.989A12.727,12.727,0,0,0,12.8,25.531ZM55.164,42.886a3.19,3.19,0,1,1-3.19-3.19A3.19,3.19,0,0,1,55.164,42.886Zm0-30.115a2.552,2.552,0,0,0-2.552-2.552H12.8a2.552,2.552,0,0,0,0,5.1H52.612A2.552,2.552,0,0,0,55.164,12.77Z",
    transform: "translate(-0.038)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSubscription);
export default __webpack_public_path__ + "static/media/ic_subscription.629b1cda89a6d5ca82357940f0d4749d.svg";
export { ForwardRef as ReactComponent };